
  import { Component, Vue, Prop } from 'vue-property-decorator';

  import { IErrorModel } from '@/models/errors.model';

  @Component
  export default class Checkbox extends Vue {
    @Prop()
    public Name!: string;

    @Prop()
    public Label!: string;

    @Prop()
    public Value!: string;

    @Prop({ default: false, type: Boolean })
    public IsPassword!: boolean;

    @Prop()
    public Errors!: Array<IErrorModel>;

    data() {
      return {
        isFocused: false,
        isLabeled: false,
        hasErrors: false,
        checkboxValue: false
      }
    };

    beforeMount() {
      this.$data.checkboxValue = this.Value;
    }

    public select() {
      this.$data.checkboxValue = !this.$data.checkboxValue;
      this.$emit('update:checkbox:value', this.Name, this.$data.checkboxValue);
    }
  }
